import { BarChart3 } from "lucide-react";

const DIFF = { easy: "facile", ok: "correct", hard: "difficile" };

const day = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("fr-CA", { day: "numeric", month: "long" });

/** Weekly review: Monday to Sunday, only what was declared. */
export const WeeklyReportCard = ({ report, mobileType = false }) => {
  const text = mobileType ? "text-[15px]" : "text-[13px]";
  return (
    <div className="w-[94%] sm:w-[88%] max-w-[23rem] self-start rounded-2xl rounded-tl-sm bg-white p-2.5 sm:p-3 shadow-sm" data-testid="weekly-report-card">
      <div className="flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#E9FBF0] text-[#189346]"><BarChart3 className="h-4 w-4" /></span>
        <div>
          <p className={`font-semibold text-[#122118] ${text}`}>Bilan de {report.student.name || "la semaine"}</p>
          <p className="text-[11px] text-[#829C8D]" data-testid="weekly-report-range">Du lundi {day(report.week.start)} au dimanche {day(report.week.end)}</p>
        </div>
      </div>
      {report.empty ? (
        <p className={`mt-3 text-[#4a5f53] ${text}`} data-testid="weekly-report-empty">
          Aucune séance d’étude déclarée cette semaine.
        </p>
      ) : (
        <>
          <div className="mt-3 grid grid-cols-3 gap-1.5 text-center">
            <div className="rounded-xl bg-[#F7FAF8] p-2"><p className="text-lg font-bold" data-testid="weekly-report-sessions">{report.sessions}</p><p className="text-[10px] uppercase text-[#829C8D]">séances</p></div>
            <div className="rounded-xl bg-[#F7FAF8] p-2"><p className="text-lg font-bold" data-testid="weekly-report-minutes">{report.minutes}{report.plannedMinutes ? <span className="text-[12px] font-semibold text-[#829C8D]">/{report.plannedMinutes}</span> : null}</p><p className="text-[10px] uppercase text-[#829C8D]">{report.plannedMinutes ? "min / prévues" : "minutes"}</p></div>
            <div className="rounded-xl bg-[#F7FAF8] p-2"><p className="text-lg font-bold" data-testid="weekly-report-help">{report.help.opened}</p><p className="text-[10px] uppercase text-[#829C8D]">aides</p></div>
          </div>
          <ul className="mt-3 space-y-1">
            {report.plans.map((plan) => (
              <li key={plan.id} className="flex justify-between text-[12px] text-[#4a5f53]" data-testid={`weekly-report-plan-${plan.id}`}>
                <span className="truncate pr-2">{plan.title}</span>
                <span className="font-semibold text-[#122118]">{plan.doneThisWeek}/{plan.perWeek}</span>
              </li>
            ))}
          </ul>
          <p className="mt-2 text-[11px] text-[#829C8D]">
            Ressenti : {Object.entries(report.difficulty).filter(([, n]) => n).map(([k, n]) => `${n} ${DIFF[k]}`).join(" · ") || "—"}
          </p>
          {report.checkins.filter((row) => row.summary).slice(0, 3).map((row) => (
            <p key={row.at} className="mt-1 text-[12px] italic text-[#4a5f53]">« {row.summary} »</p>
          ))}
        </>
      )}
    </div>
  );
};

export default WeeklyReportCard;
